import uniq from 'lodash/uniq'

import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { DropdownStringOption } from 'types/ui'
import { getCustomFieldKeys } from '@disco/state-management/selectors/user'
import {
  availableTrackHoverFields,
  availableTrackPaneFields,
  getTrackMetadataFieldName,
} from '@disco/utils/track-metadata'
import Row from 'components/common/row'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
import Label from 'components/ui/label'

const getDropdownOptionFromString = (string: string): DropdownStringOption => ({
  label: getTrackMetadataFieldName(string),
  value: string,
})

type Props = {
  showHoverField?: boolean
  // TODO: remove it, and store setting in business
  value: {
    hover: string[]
    pane: string[]
  }
  onChange: (arg0: { pane?: string[]; hover?: string[] }) => unknown
  disabled?: boolean
}

const MetadataHoverSettings = (props: Props): React.ReactNode => {
  const customFields: string[] = useSelector(getCustomFieldKeys)
  const trackHoverOptions: DropdownStringOption[] = uniq([
    ...availableTrackHoverFields,
    ...customFields,
  ]).map(getDropdownOptionFromString)
  const trackPaneOptions: DropdownStringOption[] = uniq([
    ...availableTrackPaneFields,
    ...customFields,
  ]).map(getDropdownOptionFromString)
  return (
    <>
      <Row columnsSize={[12]} marginBottom="small">
        <div>
          <Label caption="Choose the information to display on your track hover" />
          <CustomDropdown
            disabled={props.disabled}
            multi={true}
            options={trackHoverOptions}
            value={props.value.hover}
            onChange={(options: DropdownStringOption[]) => {
              const selection = options.map(option => option.value)
              props.onChange({ ...props.value, hover: selection })
            }}
          />
        </div>
      </Row>
      <Row columnsSize={[12]} marginBottom="small">
        <div>
          <Label caption="Choose metadata fields displayed in the Explorer" />
          <CustomDropdown
            disabled={props.disabled}
            multi={true}
            multiSelectLimit={5}
            multiSelectMessage="Please select a maximum of five fields to display."
            options={trackPaneOptions}
            value={props.value.pane}
            onChange={(options: DropdownStringOption[]) => {
              const selection = options.map(option => option.value)
              props.onChange({ ...props.value, pane: selection })
            }}
          />
        </div>
      </Row>
    </>
  )
}

export default MetadataHoverSettings
